import { render, staticRenderFns } from "./brandEdit.vue?vue&type=template&id=5db79ee3&"
import script from "./brandEdit.vue?vue&type=script&lang=js&"
export * from "./brandEdit.vue?vue&type=script&lang=js&"
import style0 from "./brandEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports